import { useDictionary } from "@/libs/DictionaryProvider"
import React from "react"

const MobileLoader = () => {
  const dictionary = useDictionary()
  const tHistory = dictionary.tool.bet_tracker.history
  const tArb = dictionary.tool.arbitrage

  return (
    <div className="bg-dark-8 gradient-box rounded-lg p-3 ">
      <div className="grid grid-cols-12 border-b gap-4 pb-2  my-2">
        <div className="animate-pulse flex space-x-4 col-span-6 ">
          <div className="flex-1 space-y-6 py-1">
            <div className="h-5 bg-slate-200 rounded col-span-1"></div>
          </div>
        </div>
        <div className="animate-pulse flex space-x-4 col-span-6">
          <div className="flex-1 space-y-6 py-1">
            <div className="h-5 bg-slate-200 rounded col-span-1"></div>
          </div>
        </div>
      </div>
      <div className="grid grid-cols-12 gap-2">
        <span className="flex flex-col text-sm font-regular mb-3 mt-1 col-span-3 ">
          <span className="font-semibold mr-2 !leading-5">{tArb.roi}</span>
          <div className="animate-pulse flex space-x-4 ">
            <div className="flex-1 space-y-6 py-1">
              <div className="h-5 bg-slate-200 rounded col-span-1"></div>
            </div>
          </div>
        </span>{" "}
        <span className="flex flex-col text-sm font-regular mb-3 mt-1 col-span-6">
          <span className="font-semibold mr-2 !leading-5">{tHistory.market}</span>
          <span className="!text-xs text-slate-600">
            <div className="animate-pulse flex space-x-4 ">
              <div className="flex-1 space-y-6 py-1">
                <div className="h-5 bg-slate-200 rounded col-span-1"></div>
              </div>
            </div>
          </span>
        </span>{" "}
        <span className="flex flex-col text-sm font-regular mb-3 mt-1 col-span-3 ">
          <span className="font-semibold mr-2 !leading-5">{tHistory.odds}</span>
          <span className="!text-xs text-slate-600">
            {" "}
            <div className="animate-pulse flex space-x-4 ">
              <div className="flex-1 space-y-6 py-1">
                <div className="h-5 bg-slate-200 rounded col-span-1"></div>
              </div>
            </div>
          </span>
        </span>{" "}
        <span className="flex flex-col text-sm font-regular mb-3 mt-1 col-span-3 ">
          <span className="font-semibold mr-2 !leading-5">{tHistory.sportsbook}</span>
          <span className="flex flex-col  justify-center  !text-xs text-slate-600">
            <div className="animate-pulse flex space-x-4 ">
              <div className="flex-1 space-y-6 py-1">
                <div className="h-5 bg-slate-200 rounded col-span-1"></div>
              </div>
            </div>
          </span>
        </span>{" "}
        <span className="flex flex-col text-sm font-regular mb-3 mt-1 col-span-6 ">
          <span className="font-semibold mr-2 !leading-5">{tHistory.bet}</span>
          <span className="!text-xs text-slate-600">
            {" "}
            <div className="animate-pulse flex space-x-4 ">
              <div className="flex-1 space-y-6 py-1">
                <div className="h-5 bg-slate-200 rounded col-span-1"></div>
              </div>
            </div>
          </span>
        </span>{" "}
        <span className="flex flex-col text-sm font-regular mb-3 mt-1 col-span-3 ">
          <span className="font-semibold mr-2 !leading-5">{tArb.updated}</span>
          <span className="!text-xs text-slate-600">
            {" "}
            <div className="animate-pulse flex space-x-4 ">
              <div className="flex-1 space-y-6 py-1">
                <div className="h-5 bg-slate-200 rounded col-span-1"></div>
              </div>
            </div>
          </span>
        </span>{" "}
      </div>
    </div>
  )
}

export default MobileLoader
